import { Box, Flex, Text } from "@chakra-ui/react"
import BotAvatar from "./BotAvatar"
import { BOT_BUBBLE_BG, TITLE_COLOR } from "./constants"
import {
    DEFAULT_TOOL_ACTIVITY_MESSAGE,
    FOLLOW_UP_WEBSITE_MESSAGE,
    STATUS_TOOL_TYPE,
    statusMessage,
    TOOL_ACTIVITY_MESSAGES,
} from "./toolActivityMessages"

// Returns the label for the most recent tool the agent has invoked in the
// latest assistant message, or null if it hasn't called one yet.
//
// We use the most recent tool part regardless of its state: once a tool reaches
// output-available we keep showing its label rather than flicking back to the
// default, so the indicator stays steady until the next tool starts or the
// answer text begins streaming (at which point the parent hides the indicator).
// A backend status line (StatusUpdate) is shown verbatim: it explains the wait.
function activeToolMessage(messages) {
    const last = messages[messages.length - 1]
    if (last?.role !== "assistant") return null

    const toolParts = (last.parts || []).filter(p => p.type?.startsWith("tool-"))
    const current = toolParts[toolParts.length - 1]
    if (!current) return null
    if (current.type === STATUS_TOOL_TYPE) return statusMessage(current) || DEFAULT_TOOL_ACTIVITY_MESSAGE
    if (current.type === "tool-GetConferenceInfoTool" && toolParts.length > 1) return FOLLOW_UP_WEBSITE_MESSAGE
    return TOOL_ACTIVITY_MESSAGES[current.type] || DEFAULT_TOOL_ACTIVITY_MESSAGE
}

// Shown while waiting on the agent. Displays a tool-specific label (e.g.
// "Looking up faculty…") once a tool is running, otherwise the default message.
// A caller with no tool stream (the schedule planner) passes its own `label`.
export default function ToolActivityIndicator({ messages = [], label }) {
    const message = label || activeToolMessage(messages) || DEFAULT_TOOL_ACTIVITY_MESSAGE

    return (
        <Flex gap="10px" align="flex-end" w="100%">
            <BotAvatar />
            <Box bg={BOT_BUBBLE_BG} borderRadius="12px 12px 12px 4px" px="14px" py="10px">
                <Flex gap="8px" align="center" h="21px">
                    <Text fontSize="14px" color={TITLE_COLOR} lineHeight={1.5} mt={0}>
                        {message}
                    </Text>
                    <Flex gap="4px" align="center">
                        {[0, 1, 2].map(i => (
                            <Box
                                key={i}
                                w="6px"
                                h="6px"
                                borderRadius="full"
                                bg="#94A3B8"
                                style={{
                                    animation: `typingDots 1.2s ease-in-out ${i * 0.2}s infinite`,
                                }}
                            />
                        ))}
                    </Flex>
                </Flex>
                <style>{`
                    @keyframes typingDots {
                        0%, 60%, 100% { opacity: 0.3; transform: translateY(0); }
                        30% { opacity: 1; transform: translateY(-4px); }
                    }
                `}</style>
            </Box>
        </Flex>
    )
}
